export default "__VITE_ASSET__DVvYpCLm__"